export const tabs = [
  {title: 'PM Notes', value: "pm"},
]

export const fakeTabs = [
  {title: '', value: "sm"},
  {title: '', value: "qc"},
]

export const approvedTabs = [
  {title: 'SM Notes', value: "sm"},
  {title: 'QC Notes', value: "qc"},
  {title: 'SC Notes', value: "sc"},
]

